import React from 'react';
import Button from '@mui/material/Button';
import {
    Link
  } from "react-router-dom";
import Style from './Styles/PaginationStyle'
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import LastPageIcon from '@mui/icons-material/LastPage';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import Paper from '@mui/material/Paper';

export default function UsePagination(props) {
  const classes = Style();

  const componentMethods = {
      ...props.componentMethods
  }

    const elements = []
    if(props.pagination) {
        const startPagination = props.pagination.current > 3 ? props.pagination.current - 3 : 1
        const endPagination = props.pagination.current > props.pagination.last - 3 ? props.pagination.last : props.pagination.current +  3
        for (let i = startPagination; i <= endPagination; i++) {
            elements.push(<Link key={i} style={classes.button} onClick={()=>{componentMethods.changePage(i)}} to={props.pattern.replace('{{page}}', i)}>
                <Button variant={props.pagination.current === i ? "contained" : "outlined"} color="secondary" component="span">
                    {i}
                </Button>
        </Link>)
        }
    }
  return (<Paper>
      <div style={classes.root}>
          {props.pagination ?
          <Link  style={classes.button} onClick={()=>{componentMethods.changePage(props.pagination.first)}} to={props.pattern.replace('{{page}}', props.pagination.first)}>
            <Button variant="outlined" color="secondary" component="span">
               <FirstPageIcon />
            </Button>
        </Link>
        :
        null
        }
        {
            props.pagination && props.pagination.last > 1 && props.pagination.current > 1 ?
            <Link style={classes.button} onClick={()=>{componentMethods.changePage(props.pagination.current - 1)}} to={props.pattern.replace('{{page}}', props.pagination.current - 1)}>
                <Button variant="outlined" color="secondary" component="span">
               <NavigateBeforeIcon />
            </Button>
            </Link>
            :
            null
        }
        {
        elements.map((e, i) =>{
                return e
            })
        }
        {
            props.pagination && props.pagination.last > 1 && props.pagination.current < props.pagination.last ?
            <Link  style={classes.button} onClick={()=>{componentMethods.changePage(props.pagination.current + 1)}} to={props.pattern.replace('{{page}}', props.pagination.current + 1)}>
            <Button variant="outlined" color="secondary" component="span">
               <NavigateNextIcon />
            </Button>
            </Link>
            :
            null
        }
        {props.pagination ?
        <Link  style={classes.button} onClick={()=>{componentMethods.changePage(props.pagination.last)}} to={props.pattern.replace('{{page}}', props.pagination.last)}>
            <Button variant="outlined" color="secondary" component="span">
               <LastPageIcon />
            </Button>
        </Link>
        :
        null}
      </div>
      </Paper>
  );
}